import React from 'react'
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css'
import { connect } from 'react-redux'
import { debounce, get } from 'lodash'
import { ButtonGroup, Button, Glyphicon } from 'react-bootstrap'
import moment from 'moment'
import { I18n } from 'react-redux-i18n'

import { fetchServiceTxns } from '../../actions/remote_api'
import ServiceTxnTable from './ServiceTxnTable'
import DateRangeSelector from '../commons/DateRangeSelector'
import { createDateRangeQuery } from '../../utils/dateRangeUtils'
import { createDateRange, getUserTimezone } from '../../utils/dateUtils'

class ServiceTxnTableContainer extends React.Component {
  abortController = null

  state = {
    selectionMode: 'day', // 'day' or 'month'
    selectedDate: moment(),
    year: moment().year(),
    month: moment().month(),
    filter: null,
  }

  componentDidMount() {
    this.handleDataChange = debounce(this.handleDataChange, 1000)
  }

  componentWillUnmount() {
    this.abortInFlights()
  }

  abortInFlights() {
    if (this.abortController) {
      this.abortController.abort()
      this.abortController = undefined
    }
  }

  handleSelectionModeChange = (mode) => {
    this.setState({ selectionMode: mode }, () => {
      // Trigger data refetch with updated selection mode
      if (this.state.filter) {
        this.handleDataChange(this.state.filter)
      }
    })
  }

  handleDateChange = (date) => {
    this.setState({ selectedDate: date }, () => {
      // Trigger data refetch with updated date
      if (this.state.filter) {
        this.handleDataChange(this.state.filter)
      }
    })
  }

  handleMonthChange = (field, value) => {
    this.setState({ [field]: value }, () => {
      // Trigger data refetch with updated month
      if (this.state.filter) {
        // Use saved filter from state
        this.handleDataChange(this.state.filter)
      }
    })
  }

  handleDataChange = (filter) => {
    // Save filter to state
    this.setState({ filter })

    this.abortInFlights()
    this.abortController = new AbortController()

    this.props.fetchServiceTxns(
      {
        page: filter.currentPage,
        limit: filter.sizePerPage,
        sort: filter.sort,
        order: filter.order,
        ...this.createQueryFilter(filter.query),
      },
      {
        signal: this.abortController.signal,
      },
    )
  }

  customCreateButtonGroup = (props) => <div />

  customRenderToolbar = (defaultFilterButton) => {
    return (
      <div className="pull-right flex gap-2 items-center">
        {/* <DateRangeSelector */}
        {/*   selectionMode={this.state.selectionMode} */}
        {/*   selectedDate={this.state.selectedDate} */}
        {/*   year={this.state.year} */}
        {/*   month={this.state.month} */}
        {/*   onSelectionModeChange={this.handleSelectionModeChange} */}
        {/*   onDateChange={this.handleDateChange} */}
        {/*   onMonthChange={this.handleMonthChange} */}
        {/* /> */}
        {defaultFilterButton}
      </div>
    )
  }

  createQueryFilter = (filter = {}) => {
    const queryfilter = {}

    // Add source parameter for archived data search
    if (filter.searchArchived) {
      queryfilter.source = 'archived'
    }

    if (filter.service) queryfilter['service._id'] = filter.service._id
    if (filter.flightNumber)
      queryfilter.flightNumber_like = filter.flightNumber
    if (filter.status) queryfilter.status = filter.status
    // '' is the ALL option, which intentionally omits the param
    if (filter.createByKiosk) queryfilter.createByKiosk = filter.createByKiosk
    if (filter.mainPax)
      queryfilter.reservationMainPaxName_like = filter.mainPax
    if (filter.confirmationNumber)
      queryfilter.reservationConfirmationNumber_like =
        filter.confirmationNumber

    if (filter.serviceDateTimeStart) {
      // Use timezone-aware date range for start date
      const startDateRange = createDateRange(filter.serviceDateTimeStart)
      queryfilter.serviceDateTime_gte = startDateRange.start
    }
    if (filter.serviceDateTimeEnd) {
      // Use timezone-aware date range for end date
      const endDateRange = createDateRange(filter.serviceDateTimeEnd)
      queryfilter.serviceDateTime_lte = endDateRange.end
    }

    // // Add date range query based on selection mode
    // const dateRangeQuery = createDateRangeQuery(
    //   this.state.selectionMode,
    //   this.state.selectedDate,
    //   this.state.year,
    //   this.state.month,
    // )
    // Object.assign(queryfilter, dateRangeQuery)

    return queryfilter
  }

  render() {
    return (
      <ServiceTxnTable
        {...this.props}
        defaultSortName="serviceDateTime"
        defaultSortOrder="desc"
        options={{ btnGroup: this.customCreateButtonGroup }}
        settings={{ insertRow: false, deleteRow: false, selectRow: undefined }}
        customDefaultSizePerPage={10}
        onDataChange={this.handleDataChange}
        customRenderToolbar={this.customRenderToolbar}
      />
    )
  }
}

export default connect(
  ({ fetch, auth }) => ({
    isLoading: get(fetch, 'serviceTxn.isLoading.list', false),
    instances: get(fetch, 'serviceTxn.list', []),
    totalCount: get(fetch, 'serviceTxn.totalCount'),
    auth,
  }),
  { fetchServiceTxns },
)(ServiceTxnTableContainer)
